import React from "react";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator";
import { useProductCatalog } from "../../hooks/useProductCatalog";
import CatalogHero from "../CatalogHero/CatalogHero";
import CategoryFilter from "../CategoryFilter/CategoryFilter";
import CatalogSection from "../CatalogSection/CatalogSection";

export default function CatalogPage() {
  const {
    categories,
    countsByCategoryId,
    heroProducts,
    loading,
    sections,
    selectedCategoryId,
    setSelectedCategoryId,
    totalCount,
  } = useProductCatalog();

  return (
    <MainPageWrapper
      subtitle="Browse CertainPath products and services"
      title="Product Catalog"
    >
      {loading ? (
        <LoadingIndicator />
      ) : totalCount === 0 ? (
        <div className="py-16 text-center">
          <h2 className="text-base font-normal text-gray-900 dark:text-white">
            Nothing here yet
          </h2>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Products and services will appear here once they&apos;re published.
          </p>
        </div>
      ) : (
        <div className="space-y-8">
          <CatalogHero products={heroProducts} />

          <CategoryFilter
            categories={categories}
            countsByCategoryId={countsByCategoryId}
            onSelect={setSelectedCategoryId}
            selectedCategoryId={selectedCategoryId}
            totalCount={totalCount}
          />

          <div className="space-y-10">
            {sections.map((section) => (
              <CatalogSection key={section.category.id} section={section} />
            ))}
          </div>
        </div>
      )}
    </MainPageWrapper>
  );
}
